import { routes } from "router/routes"
import { SettingsCard } from "ui/SettingsCard"
import { isFeatureEnabled } from "config/features"
import { usePermissions } from "hooks/usePermissions"
import { MODULES, ACTIONS } from "utils/permissions"
import styles from "./ProSettings.module.css"

export const settingsMenuList = [
  {
    name: "Profile Information",
    id: "profile-information",
    iconName: "user",
    path: routes.proSettingsProfileInformation(),
    requiresFullAccess: false
  },
  {
    name: "Profile Images",
    id: "profile-images",
    iconName: "userCircle",
    path: routes.proSettingsProfileImages(),
    requiresFullAccess: false
  },
  {
    name: "Login & Security",
    id: "login-security",
    iconName: "password",
    path: routes.proSettingsLoginAndSecurity(),
    requiresFullAccess: false
  },
  {
    name: "Mode Preferences",
    id: "mode-preferences",
    iconName: "brush",
    path: routes.proSettingsAdventureMode(),
    requiresFullAccess: false
  },
  {
    name: "Payment Providers",
    id: "payment-providers",
    iconName: "card",
    path: routes.proSettingsPaymentProviders(),
    requiresFullAccess: true
  },
  {
    name: "Social Networks",
    id: "social-networks",
    iconName: "link",
    path: "",
    comingSoon: true,
    requiresFullAccess: true
  },
  {
    name: "Licenses",
    id: "licenses",
    iconName: "license",
    path: routes.proSettingsLicenses(),
    requiresFullAccess: true
  },
  {
    name: "Billing",
    id: "billing",
    iconName: "investment",
    path: "",
    comingSoon: true,
    requiresFullAccess: true
  },
  {
    name: "Google Calendar",
    id: "google-calendar",
    iconName: "calendar",
    path: routes.proSettingsGoogleCalendar(),
    requiresFullAccess: true
  },
  {
    name: "Website Integration",
    id: "website-integration",
    iconName: "Code",
    path: routes.proSettingsWebsiteIntegration(),
    requiresFullAccess: true
  },
  {
    name: "Account Management",
    id: "account-management",
    iconName: "settings",
    path: routes.proSettingsAccountManagement(),
    requiresFullAccess: true
  },
  {
    name: "Custom Questions",
    id: "custom-questions",
    iconName: "messagesSquare",
    path: routes.proSettingsCustomTemplate(),
    featureFlag: "CUSTOM_TEMPLATE",
    requiresFullAccess: true
  }
]
export const ProSettings = () => {
  const { hasPermission } = usePermissions()

  const visibleMenuItems = settingsMenuList.filter((menu) => {
    if (menu.featureFlag && !isFeatureEnabled(menu.featureFlag)) {
      return false
    }
    if (menu.requiresFullAccess && !hasPermission(MODULES.SETTINGS, ACTIONS.FULL_ACCESS)) {
      return false
    }

    return true
  })

  return (
    <div className={styles.wrapper}>
      {visibleMenuItems.map((menu) => (
        <SettingsCard key={menu.id} title={menu.name} iconName={menu.iconName} path={menu.path} comingSoon={menu.comingSoon} />
      ))}
    </div>
  )
}
